/**
 * Filters NAV_SECTIONS to what the signed-in user may see (empty sections
 * are dropped). Client-side only for UX — the API enforces every permission.
 */

import { useMemo } from 'react';

import { useAuth } from '@/hooks';

import { NAV_SECTIONS, type NavItem, type NavSection } from './nav-config';

export function filterNav(sections: NavSection[], role: string, hasPermission: (code: string) => boolean): NavSection[] {
  const visible = (item: NavItem) => {
    if (item.role && item.role.toLowerCase() !== role) return false;
    if (!item.permission) return true;
    const perms = Array.isArray(item.permission) ? item.permission : [item.permission];
    return perms.some((p) => hasPermission(p));
  };
  return sections.map((s) => ({ ...s, items: s.items.filter(visible) })).filter((s) => s.items.length > 0);
}

export function useVisibleNav(): NavSection[] {
  const { hasPermission, user } = useAuth();
  const role = (user?.role || '').toLowerCase();
  return useMemo(() => filterNav(NAV_SECTIONS, role, hasPermission), [role, hasPermission]);
}
